<template>
  <b-card class="bathroom-card mb-0" no-body>

    <div class="bathroom-card__header d-flex align-items-center px-2 py-75">
      <feather-icon icon="DropletIcon" size="13" class="text-primary mr-75 flex-shrink-0" />
      <span class="font-weight-bold small">{{ title }}</span>
    </div>

    <div class="px-1 py-75">
      <div class="small font-weight-bold">{{ bathroomSpecsText }}</div>
      <small v-if="bathroom.ensuite && ensuiteText" class="text-muted">{{ ensuiteText }}</small>
      <small v-else class="text-muted">{{ $t("Independent") }}</small>
    </div>

  </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";

export default {
  components: {
    BCard, FeatherIcon,
  },
  props: {
    bathroom: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    bedrooms() {
      return this.$store.getters["accommodation/bedrooms"];
    },
    ensuiteText() {
      if (!this.bathroom.ensuite) return null;
      let bedroomIndex = null;
      if (this.bedrooms.length > 0) {
        this.bedrooms.forEach((bedroom, index) => {
          if (!bedroomIndex && bedroom.bathroom === this.bathroom["@id"]) {
            bedroomIndex = index + 1;
          }
        });
      }
      return bedroomIndex
        ? `${this.$t("pages.accommodation.bathroomEnsuiteTo")} ${bedroomIndex}`
        : null;
    },
    bathroomSpecsText() {
      const specs = [];
      if (this.bathroom.toilets > 0) specs.push("WC");
      if (this.bathroom.bathtubs > 0) {
        const t = this.$t("Bathtub");
        specs.push(t.charAt(0).toUpperCase() + t.slice(1));
      }
      if (this.bathroom.showers > 0) {
        const t = this.$t("Shower");
        specs.push(t.charAt(0).toUpperCase() + t.slice(1));
      }
      return specs.length > 0 ? specs.join(", ") : this.$t("Not defined");
    },
  },
};
</script>

<style lang="scss">
.bathroom-card {
  &__header {
    background-color: #f6f6f6;
  }
}
</style>
